import React from 'react';
import styled from 'styled-components';
import { Tap } from '../';
import classNames from 'classnames';

const KeyWrapper = styled.div`
  user-select: none;
  tap-highlight-color: rgba(0, 0, 0, 0);
  transition: transform 0.15s ease-out, opacity 0.15s ease-in-out;
  display: block;
  cursor: pointer;
  flex: 70px 0;
  padding: 10px 5px;
  color: #444;

  &.pressed {
    transform: scale(0.9);
  }

  opacity: 0.6;

  &.enabled {
    opacity: 1;
  }

  & > div {
    background: ${({ theme }) => theme.keyboardBackgroundColor || '#FE0000'};
    color: ${({ theme }) => theme.keyboardTextColor || 'white'};
    display: block;
    text-align: center;
    line-height: 80px;
    vertical-align: middle;
    border-radius: 10px;
    padding: 20px 0 10px 0;
    font-family: ${({ theme }) => theme.inputFont || 'Roboto'};
    font-weight: normal;
    font-style: normal;
  }

  &.space.pressed {
    transform: scale(0.95);
  }

  &.space {
    flex: 453px 0;
  }

  &.backspace > div,
  &.enter > div {
    padding-left: 30px;
    padding-right: 30px;
  }

  &.hide-key {
    visibility: hidden;
  }
`;

class Key extends React.Component {
  constructor(props) {
    super(props);
    this.state = { pressed: false };
  }

  render() {
    const { className, label, enabled } = this.props;
    const cls = classNames('Key', className, {
      pressed: this.state.pressed,
      enabled,
    });
    return (
      <KeyWrapper className={cls}>
        <Tap onTap={this.handlePress} preventDoubleTap={false}>
          {label}
        </Tap>
      </KeyWrapper>
    );
  }

  handlePress = () => {
    if (!this.props.enabled) return;
    if (this.props.onKey) this.props.onKey(this.props.value);
    this.setState({ pressed: true });
    setTimeout(() => this.setState({ pressed: false }), 150);
  };
}

const RowWrapper = styled.div`
  display: flex;
  justify-content: center;
  font-size: 50px;

  &.letters3name {
    left: 0;
  }

  &.emailSpecial .Key {
    font-size: 50px;
  }

  &.emailSpecial .Key.small {
    font-size: 30px;
  }

  &.emailSpecial .Key.small > div {
    padding-left: 10px;
    padding-right: 10px;
  }

  &.numbers .Key > div {
    min-width: 120px;
    height: 120px;
    line-height: 120px;
  }
`;

const Row = props => (
  <RowWrapper
    className={classNames('Row', props.row.groupName, props.row.className)}
  >
    {props.row.keys.map((k, i) => (
      <Key
        key={i}
        label={k.label}
        className={k.className}
        value={k.value}
        enabled={props.isKeyEnabled(k.value)}
        onKey={props.onKey}
      />
    ))}
  </RowWrapper>
);

const KeyboardWrapper = styled.div``;

class Keyboard extends React.Component {
  static defaultProps = {
    isKeyEnabled: value => true,
  };

  componentDidMount() {
    document.addEventListener('keypress', this.handleKeyPress);
    document.addEventListener('keydown', this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener('keypress', this.handleKeyPress);
    document.removeEventListener('keydown', this.handleKeyDown);
  }

  render() {
    let { layout, onKey, className, isKeyEnabled } = this.props;

    return (
      <KeyboardWrapper className={classNames('Keyboard', className)}>
        {layout.map(row => (
          <Row key={row.groupName} {...{ row, onKey, isKeyEnabled }} />
        ))}
      </KeyboardWrapper>
    );
  }

  handleKeyDown = e => {
    if (e.code === 'Backspace' || e.key === 'Backspace') {
      this.props.onKey('backspace');
    }
  };

  handleKeyPress = e => {
    if (e.charCode === 13) {
      // enter
      if (this.props.isKeyEnabled('enter')) this.props.onKey('enter');
    } else if (e.charCode === 32) {
      // space
      if (this.props.isKeyEnabled('space')) this.props.onKey('space');
    } else {
      let ch = String.fromCharCode(e.charCode);
      if (this.props.isKeyEnabled(ch)) this.props.onKey(ch);
    }
  };
}

export const HR_LAYOUT = [
  {
    groupName: 'numbers1',
    keys: '1234567890'.split('').map(k => ({ label: k, value: k })),
  },
  {
    groupName: 'letters1',
    keys: 'qwertzuiopšđ'.split('').map(k => ({ label: k, value: k })),
  },
  {
    groupName: 'letters2',
    keys: 'asdfghjklčćž'.split('').map(k => ({ label: k, value: k })),
  },
  {
    groupName: 'letters3',
    keys: 'yxcvbnm.,-'.split('').map(k => ({ label: k, value: k })),
  },
  {
    groupName: 'space',
    keys: [
      { label: 'Briši', value: 'backspace', className: 'backspace' },
      { label: '\u00a0', value: 'space', className: 'space' },
      { label: 'Dalje', value: 'enter', className: 'enter' },
    ],
  },
];

export const EMAIL_LAYOUT = [
  {
    groupName: 'numbers1',
    keys: '1234567890'.split('').map(k => ({ label: k, value: k })),
  },
  {
    groupName: 'letters1',
    keys: 'qwertzuiop'.split('').map(k => ({ label: k, value: k })),
  },
  {
    groupName: 'letters2',
    keys: 'asdfghjkl'.split('').map(k => ({ label: k, value: k })),
  },
  {
    groupName: 'letters3',
    keys: 'yxcvbnm'.split('').map(k => ({ label: k, value: k })),
  },
  {
    groupName: 'space',
    keys: [
      { label: 'Briši', value: 'backspace', className: 'backspace' },
      { label: '\u00a0', value: 'space', className: 'space' },
      { label: 'Dalje', value: 'enter', className: 'enter' },
    ],
  },
];

export const NAME_LAYOUT = [
  {
    groupName: 'letters1',
    keys: 'qwertzuiopšđ'.split('').map(k => ({ label: k, value: k })),
  },
  {
    groupName: 'letters2',
    keys: 'asdfghjklčćž'.split('').map(k => ({ label: k, value: k })),
  },
  {
    groupName: 'letters3name',
    keys: 'yxcvbnm'.split('').map(k => ({ label: k, value: k })),
  },
  {
    groupName: 'space',
    keys: [
      { label: 'Briši', value: 'backspace', className: 'backspace' },
      { label: '\u00a0', value: 'space', className: 'space' },
      { label: 'Dalje', value: 'enter', className: 'enter' },
    ],
  },
];

export const NUM_LAYOUT = [
  {
    groupName: 'numbers1',
    className: 'numbers',
    keys: '123'.split('').map(k => ({ label: k, value: k })),
  },
  {
    groupName: 'numbers2',
    className: 'numbers',
    keys: '456'.split('').map(k => ({ label: k, value: k })),
  },
  {
    groupName: 'numbers3',
    className: 'numbers',
    keys: '789'.split('').map(k => ({ label: k, value: k })),
  },
  {
    groupName: 'space',
    className: 'numbers',
    keys: [
      { label: 'Briši', value: 'backspace', className: 'backspace' },
      { label: '0', value: '0' },
      { label: 'Dalje', value: 'enter', className: 'enter' },
    ],
  },
];

export const BIRTH_LAYOUT = [
  {
    groupName: 'numbers1',
    className: 'numbers',
    keys: '123'.split('').map(k => ({ label: k, value: k })),
  },
  {
    groupName: 'numbers2',
    className: 'numbers',
    keys: '456'.split('').map(k => ({ label: k, value: k })),
  },
  {
    groupName: 'numbers3',
    className: 'numbers',
    keys: '789'.split('').map(k => ({ label: k, value: k })),
  },
  {
    groupName: 'space',
    className: 'numbers',
    keys: [
      { label: 'Briši', value: 'backspace', className: 'backspace' },
      { label: '0', value: '0' },
      { label: '.', value: '.' },
      { label: 'Dalje', value: 'enter', className: 'enter' },
    ],
  },
];

export default Keyboard;
